import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  actionBtn: {
    display: 'flex',
    flexDirection: 'row-reverse',
    margin: '1rem 0 1rem 0',
    marginBottom: '0',
  },

  btn: {
    padding: '0.5rem',
    textAlign: 'center',
    height: '2.625rem',
    width: '11rem',
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem',
  },

  closeIcon: {
    cursor: 'pointer',

    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}))

export default useStyles
